import { render } from "./AIAnalytics.vue?vue&type=template&id=4c6a99c6"
import script from "./AIAnalytics.vue?vue&type=script&lang=js"
export * from "./AIAnalytics.vue?vue&type=script&lang=js"

import "./AIAnalytics.vue?vue&type=style&index=0&id=4c6a99c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__